module.exports = __webpack_public_path__ + "static/media/signage-indoor-img34.d8dc0606.jpg";